<template>

  <div>

    <transition
      name="slide-left"
      mode="out-in">

      <div
        v-if="screenThree.show1">
        <div
          class="buymodal-block__body">

          <div
            class="body-info">
            <div
              class="body-info__title">
              Расчет стоимости выкупа
            </div>
            <div
              class="body-info__block">
              <div
                class="info-table">
                <div
                  v-if="model.imei"
                  class="info-table__line">
                  <div
                    class="label">
                    IMEI
                  </div>
                  <div
                    class="value">
                    {{ model.imei }}
                  </div>
                </div>
                <div
                  class="info-table__line"
                  v-for="(item, i) in model.mobile" :key="i"
                  v-if="arrayName.find(item => item.key === i)">
                  <div
                    class="label">
                    {{ arrayName.find(item => item.key === i).name }}
                  </div>
                  <div
                    class="value">
                    {{ item }}
                    <span v-if="i === 'model'"> (Устройство не найдено в прайсе, можно выкупить по минимальной цене)</span>
                  </div>
                </div>
                <div
                  class="info-table__line">
                  <div
                    class="label">
                    Грейд:
                  </div>
                  <div
                    class="value">
                    {{ grade }}
                  </div>
                </div>
                <div
                  class="info-table__line"
                  v-for="(item, i) in discounts" :key="i">
                  <div
                    class="label">
                    {{ item.name }}
                  </div>
                  <div
                    class="value">
                    {{ item.description }} <a
            type="button"
            class="btn"
            @click.prevent="buyDiscount(item.discountId,item.discountPriceId,item.price,item.name)">
            Выкупить по акции
          </a>
                  </div>
                </div>
              </div>
              <div
                class="info-image">
                <div
                  class="info-image__img"
                  v-html="model.mobile.img">
                </div>
                <div
                  v-if="price"
                  class="info-image__price">
                  <div
                    class="info-image__price-title">
                    Стоимость выкупа:

                  </div>
                  <div
                    class="info-image__price-text">
                    {{ price }} ₸
                  </div>
                                    <div
                    class="info-image__price-discount"
                    v-if="selectDiscount">
                    Применена акция: </br>
                    {{selectDiscount}}
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

        <div
          class="buymodal-block__footer">
          <button
            type="button"
            class="btn cancel"
            @click.prevent="$emit('leave')">
            Отказаться
          </button>
          <button
            type="button"
            class="btn next"
            @click.prevent="next()">
            Продолжить
          </button>
        </div>

      </div>

      <user-info
        v-if="screenThree.show2"
        @leave="$emit('leave')" />

      <all-info
        v-if="screenThree.show3"
        @leave="$emit('leave')"
        @changeScreen="changeScreen" />

    </transition>

  </div>

</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';

import UserInfo from './ScreenThree/UserInfo';
import AllInfo from './ScreenThree/AllInfo';

export default {
  components: {
    UserInfo,
    AllInfo,
  },
  data() {
    return {
      arrayName: [
        { key: 'IMEI', name: 'IMEI' },
        // { key: 'SerialNumber', name: 'Серийный номер' },
        { key: 'ModelName', name: 'Модель' },
        { key: 'Capacity', name: 'Объем' },
        // { key: 'Color', name: 'Цвет' },
        { key: 'manufactorer', name: 'Производитель' },
        { key: 'model', name: 'Модель' },
      ],
    }
  },
  computed: {
    ...mapState('buyphones', ['model', 'price','grade', 'answers', 'screenThree','discounts','selectDiscount'])
  },
  methods: {
    ...mapActions('buyphones', ['agreeModel','changeDiscount','updatePrice','clearDiscount']),
    ...mapMutations('buyphones', ['SET_MODEL', 'CHANGE_SCREEN_THREE']),

    async next() {
      const response = await this.agreeModel({
        btag: this.model.btag,
      })

      if (response && response.ErrorDetails)
        return false;

      // this.$router.push(`/buyout/create?id=${this.model.btag}`);
    },
    async buyDiscount(discountId,priceId,price,discountName) {
      const response = await this.changeDiscount({
        btag: this.model.btag,
        discountId: discountId,
        priceId: priceId,
      })
      if (response.status == 'ok'){
        this.clearDiscount(discountName)
        this.updatePrice(price)

      }

    },
    changeScreen() {
      this.$emit('changeScreen', {type: 'next', id: 2})
    },
  }
}
</script>

<style lang="css">
</style>
